import type { Project } from '@/types/nest/projects'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { UUID } from 'node:crypto'
import { axiosClient } from '@/utils/axios-client'

export const useProjectStore = defineStore('projectStore', () => {
  const projects = ref<Project[]>([])
  const selectedProject = ref<Project | null>(null)

  async function fetchProjects() {
    const response = await axiosClient.request<Project[]>({
      url: '/projects',
      method: 'GET',
    })

    projects.value = response.data
  }

  async function fetchProject(id: UUID) {
    const response = await axiosClient.request<Project>({
      url: `/projects/${id}`,
      method: 'GET',
    })

    selectedProject.value = response.data
  }

  async function createProject(project: Project) {
    const response = await axiosClient.request<Project>({
      url: '/projects',
      method: 'POST',
      data: project,
    })

    projects.value.push(response.data)
  }

  async function updateProject(project: Partial<Project>) {
    await axiosClient.request<Project>({
      url: `/projects/${project.id}`,
      method: 'PATCH',
      data: project,
    })

    if (selectedProject.value && selectedProject.value.id === project.id) {
      selectedProject.value = { ...selectedProject.value, ...project }
    }
  }

  async function deleteProject(projectId: string) {
    await axiosClient.request({
      url: `/projects/${projectId}`,
      method: 'DELETE',
    })

    projects.value = projects.value.filter(project => project.id !== projectId)
  }

  return {
    projects,
    selectedProject,
    fetchProjects,
    fetchProject,
    createProject,
    updateProject,
    deleteProject,
  }
})
